import { usePathname } from 'next/navigation';
import * as S from './styles';
import Breadcrumbs from '@/components/molecules/Breadcrumbs';
import { BreadcrumbPaginaProps } from '../..';

export default function BreadcrumbsPaginaDesktop(props: BreadcrumbPaginaProps) {
  const { $nomePaginaAtual, style = {}, $linkDefault = undefined } = props;
  const caminhoURL = usePathname();

  return (
    <S.Container style={style}>
      <Breadcrumbs
        linkDefault={$linkDefault}
        links={[
          {
            atual: true,
            href: caminhoURL,
            texto: $nomePaginaAtual,
          },
        ]}
        style={{
          maxWidth: 1280,
          margin: '0 auto',
        }}
      />
    </S.Container>
  );
}
